import React from "react";
import { motion } from "framer-motion";
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import "../errorMessage/errorMessage.scss";

const ErrorMessage = ({ errorMessage }) => {

    return !errorMessage ? (<div />) : (
        <motion.div
            className="errorMessage"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.1, ease: "easeOut" }}
        >
            <ErrorOutlineOutlinedIcon />
            <span>{errorMessage}</span>
        </motion.div >
    );
};

export default ErrorMessage;